<template>
    <section class="container">
      <div class="route">
        {{$locales.cambiocuenta}}
      </div>
      <div class="wide-window">
        <h1>{{$locales.cambiocuenta}}</h1>
        <div class="app-cambiarCuenta">
                  <p class="app-seleccionarProveedor-perlog">* Selecciona el proveedor con el que quieres operar</p>
                  <div class="form-field-wrapper">
                    <div class="form-field-flex">
                      <div class="form-field-infix">
                        <input type="text" id="buscador" v-on:keyup="buscar" v-model="textoBuscador" class="inputComponent">
                        <span class="form-field-label-wrapper">
                          <!---->
                        </span>
                      </div>
                      <div class="form-field-suffix">
                        <span class="material-icons app-seleccionarProveedor-search-icon">search</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-contSelProveedor">
                    <div :class = "listaProveedores.length>4?'app-seleccionarProveedor-list':'app-seleccionarProveedor-low-list'">
                      <button type="button" v-for="persona in listaProveedores" v-bind:key="persona.id" class="btnPrimary app-seleccionarProveedor-button" @click="onSeleccionarProveedor(persona.id)">
                        <span>{{persona.contractName}}</span>
                      </button>
                    </div>
                  </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
    name : 'ChangeAccountComponent',
    data(){
      return{
        textoBuscador:null,
        listaProveedores:JSON.parse(this.$cookies.get('providersList'))
      }
    },
    created(){
        let loader = this.$loading.show();
        setTimeout(() => {
          loader.hide();
        },700);
    },
    methods : {
    onSeleccionarProveedor(id){
      let loader = this.$loading.show();
        setTimeout(() => {
          var proveedor=this.listaProveedores.find(x => x.id === id);
          this.$cookies.set('providerSelected',proveedor); //guardamos el proveedor seleccionado en una cookie, como contextualizarlo
          this.$http.defaults.headers.common['X-USER-PROFILE-ID'] = id;
          this.$router.push('/onesaitConfirmingProviders/home');
          loader.hide();
        },700);
        
    },
    buscar(){
      var textoBuscador=this.textoBuscador;
      document.getElementsByClassName("app-seleccionarProveedor-button").forEach(function(boton){
        if(boton.innerText.toLowerCase().indexOf(textoBuscador.toLowerCase())>=0){
          boton.style.display="";
        }else{
          boton.style.display="none";
        }
      });
    }
  }
}
</script>